import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik  } from 'formik';
import { useEffect, useState } from "react";
import { Alert, Autocomplete, Divider, Grid, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { Props } from "./ModalScheduleCompany.type";
import { ScheduleService } from "@/service/services/Schedule.service";
import ___PHRASE from "@/service/translate/translateService";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";

export const ModalScheduleCompany: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, schedule, onList, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [workShiftOptions,setWorkShiftOptions] = useState<string[]>([]);
    const [workTimeOptions, setWorkTimeOptions] = useState<string[]>([]);
    const [workShiftSelected, setWorkShiftSelectede] = useState(null);
    const [workTimeSelected, setWorkTimeSelected] = useState(null);

    const [data, setData] = useState({
        id:  schedule ? schedule.id : '',
        check_in_times: schedule ? schedule.check_in_times : '',
        closing_hour: schedule ? schedule.closing_hour : '',
        tolerance_minutes: schedule ? schedule.tolerance_minutes : '',
    });

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    useEffect(()=>{
        getWorkShift();
        getWorkTime();
    },[])

    const getWorkShift = async() => {
        await ScheduleService.getWorkingShift().then((data) => {
            setWorkShiftOptions(data.data)
            if(actionSelected=='edit'){
                const newObj = data.data.find( item => item.id == schedule.idworkshift  )
                setWorkShiftSelectede(newObj)
            }
        })
    }

    const getWorkTime = async() => {
        await ScheduleService.getWorkingTime().then((data) => {
            setWorkTimeOptions(data.data)
            if(actionSelected=='edit'){
                const newObj = data.data.find( item => item.id == schedule.idworkingtime  )
                setWorkTimeSelected(newObj)
            }
        })
    }

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.check_in_times) errors.check_in_times = "requerido";
        if(!values.closing_hour) errors.closing_hour = "requerido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            id: values.id,
            check_in_times: values.check_in_times,
            closing_hour : values.closing_hour,
            tolerance_minutes : values.tolerance_minutes,
            idworkshift: 1,
            idworkingtime: workTimeSelected.id
        }
        setLoading(true);
        if(schedule && actionSelected=='edit'){
            await ScheduleService.editScheduleCompany(schedule.id, formData).then((data) => {
                let apimessagge = apiResponseTranslate(data?.data?.message || '');
                if(data.data.status == true){
                    setSnackBarConfig(prev => ({ ...prev, open: true, 
                        severity:'success', 
                        message: `${apimessagge || ___PHRASE("horarioEditadoSatisfactoriamente")}`}
                    ))
                    onList && onList();
                    setTimeout(function(){
                        closeModal && closeModal();
                        clearState && clearState();
                    }, 1000);
                }else{
                    setSnackBarConfig(prev => ({ ...prev, open: true, 
                        severity:'error', 
                        message: ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}
                    ))
                }
            })
        }else{
            await ScheduleService.createScheduleCompany(formData).then((data) => {
                let apimessagge = apiResponseTranslate(data?.data?.message || '');
                if(data.data.status == true){
                    setSnackBarConfig(prev => ({ ...prev, open: true, 
                        severity:'success', 
                        message: `${apimessagge || ___PHRASE("horarioCreadoSatisfactoriamente")}`}
                    ))
                    onList && onList();
                    setTimeout(function(){
                        closeModal && closeModal();
                        clearState && clearState();
                    }, 1000);
                }else{
                    setSnackBarConfig(prev => ({ ...prev, open: true, 
                        severity:'error', 
                        message: ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}
                    ))
                }
            })
        }
        setLoading(false);
    }

    return(
        <>
        {loading && <Loading/>}

        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(schedule ? ___PHRASE("editar") : ___PHRASE("agregar"))+' '+___PHRASE("horario")}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE("horarioDeEntrada")}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="check_in_times"
                                            variant="standard"
                                            type="time" 
                                            name="check_in_times"
                                            fullWidth
                                            value={values.check_in_times}
                                            onChange={handleChange}
                                            placeholder={___PHRASE("horarioDeEntrada")}
                                            error={errors.check_in_times && touched.check_in_times ? true : false}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE("toleranciaMin")}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="tolerance_minutes"
                                            variant="standard"
                                            type="number" 
                                            name="tolerance_minutes"
                                            fullWidth
                                            value={values.tolerance_minutes}
                                            onChange={handleChange}
                                            placeholder={___PHRASE("minutosDeTolerancia")}
                                            error={errors.tolerance_minutes && touched.tolerance_minutes ? true : false}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE("horarioDeSalida")}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="closing_hour"
                                            variant="standard"
                                            type="time" 
                                            name="closing_hour"
                                            fullWidth
                                            value={values.closing_hour}
                                            onChange={handleChange}
                                            placeholder={___PHRASE("horarioDeSalida")}
                                            error={errors.closing_hour && touched.closing_hour ? true : false}
                                        />
                                        </Grid>
                                    </Grid>
                                    {/* <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="body1"><b>Jornada:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                id="disable-portal"
                                                disablePortal
                                                value={workShiftSelected}
                                                options={workShiftOptions || []}
                                                getOptionLabel={(option) => option.name || ""}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="standard" label={___PHRASE("escribeParaBuscar")} />}
                                                onChange={(e, newValue) => {  setWorkShiftSelectede(newValue) }}
                                            />
                                        </Grid>
                                    </Grid> */}
                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="body1"><b>{___PHRASE("tipo")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Autocomplete
                                                id="disable-portal"
                                                disablePortal
                                                value={workTimeSelected}
                                                options={workTimeOptions || []}
                                                getOptionLabel={(option) => option.name || ""}
                                                fullWidth
                                                renderInput={(params) => <TextField {...params} variant="standard" label={___PHRASE("escribeParaBuscar")} />}
                                                onChange={(e, newValue) => {  setWorkTimeSelected(newValue) }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(schedule && actionSelected=='edit') ? ___PHRASE("actualizar") : ___PHRASE("registrar")}
                                    cancelText={___PHRASE("cancelar")}
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}